module.exports = __webpack_public_path__ + "img/pic_6.d42cc408.jpg";